// extracted by mini-css-extract-plugin
export default {"container":"Wallet_container__7ccBA","main":"Wallet_main__fcbHc","body":"Wallet_body__UnBRc"};